import { Slot } from '@radix-ui/react-slot';
import { cn } from '@sohanemon/utils';
import * as React from 'react';

type ListProps = React.ComponentPropsWithoutRef<'div'> & {
	as?: React.ElementType;
	asChild?: boolean;
};

function List({ className, as = 'div', asChild, ...props }: ListProps) {
	const Comp = asChild ? Slot : as;
	return React.createElement(Comp, {
		'data-slot': 'list',
		className: cn('[&>[data-slot=list-item]:last-child]:border-b', className),
		...props,
	});
}

type ListItemProps = React.ComponentPropsWithoutRef<'div'> & {
	as?: React.ElementType;
	asChild?: boolean;
};

function ListItem({ className, as = 'div', asChild, ...props }: ListItemProps) {
	const Comp = asChild ? Slot : as;
	return React.createElement(Comp, {
		'data-slot': 'list-item',
		className: cn(
			'group peer relative border-border/40 border-t transition-colors duration-300 hover:border-primary/40 focus-within:border-primary/40 [.peer:focus-within+&]:border-t-primary/40 [.peer:hover+&]:border-t-primary/40',
			className,
		),
		...props,
	});
}

export { List, ListItem };
